import React from 'react'
import cx from 'classnames'

import { Text } from 'components/dataDisplay'

import s from './CountWithText.scss'


type CountWithTextProps = {
  className?: string
  count: string | number
  countSize?: 'h32' | 'h40'
  text: string
}

const CountWithText: React.FC<CountWithTextProps> = (props) => {
  const { className, count, countSize = 'h32', text } = props

  const sanitizedCount = Number(String(count).replace(' ', ''))
  const hasCount = sanitizedCount >= 0

  return (
    <div className={cx(s.container, className)}>
      <Text
        message={hasCount ? sanitizedCount.toLocaleString() : '&nbsp;'}
        size={countSize}
        color="alien"
        html
      />
      <Text
        className="mt-4px opacity-64"
        message={text}
        size="s13-r"
        color="titanic"
      />
    </div>
  )
}


export default CountWithText
